<template>
    <div class="mt-5">
        <div class="grid grid-cols-2 gap-4">
            <div>
                <CheckboxCircle v-model:check="inputValueRecommended" text="อู่สีส้ม (อู่แนะนำ)" singleLine borderColor="orange" />
            </div>
            <div>
                <CheckboxCircle v-model:check="inputValueTruck" text="อู่ซ่อมรถบรรทุก" singleLine borderColor="orange" />
            </div>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent } from 'vue';

// component
import CheckboxCircle from '@/components/Input/simple/CheckboxCircle.vue';

export default defineComponent({
    props: {
        recommended: {
            type: Boolean
        },
        truck: {
            type: Boolean
        }
    },
    components: {
        CheckboxCircle
    },
    emits: ["update:recommended", "update:truck"],
    setup: function (props, context) {
        const inputValueRecommended = computed({
            get: function () {
                return props.recommended
            },
            set: function (val) {
                // console.log(val)
                context.emit("update:recommended", val)
            }
        })

        const inputValueTruck= computed({
            get: function () {
                return props.truck
            },
            set: function (val) {
                // console.log(val)
                context.emit("update:truck", val)
            }
        })

        return {
            inputValueRecommended,
            inputValueTruck
        }
    }
})
</script>

